import { BETA_BASE_ROUTE, BH_ROUTES } from "../../constants";
export function isInvitePage(locale) {
    const betaBaseRoute = `${BETA_BASE_ROUTE}/${locale}`;
    const currentPath = window.location.pathname.replace(betaBaseRoute, "");
    return currentPath === BH_ROUTES.INVITE_BASE;
}
//# sourceMappingURL=isInvitePage.js.map